import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    CloudyIconWrapper,
    OvercastIconWrapper,
    RainIconWrapper,
    ShowersIconWrapper,
    SnowIconWrapper,
    SunnyIconWrapper,
} from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardHeader/WeatherIcons.style';

interface WeatherIconsPropsType {
    value: string;
}

const weatherIconMap: Record<string, JSX.Element> = {
    Cloudy: <CloudyIconWrapper />,
    Fine: <SunnyIconWrapper />,
    Overcast: <OvercastIconWrapper />,
    Rain: <RainIconWrapper />,
    Showers: <ShowersIconWrapper />,
    Snow: <SnowIconWrapper />,
};

export const WeatherIcons = observer(({ value }: WeatherIconsPropsType): JSX.Element | null => {
    const iconName = value.trim();

    if (iconName === '') {
        return null;
    }

    const key = iconName.split(' ')[0] ?? '';

    if (key !== '' && key in weatherIconMap) {
        return weatherIconMap[key] ?? null;
    }

    return null;
});
